<div class="stravaItem">
  <app-polyline-map
    [height]="'16vw'"
    [width]="'16vw'"
    [showBaseLayer]="true"
    [mapId]="mapId"
    [layer]="'road'"
    *ngIf="
      activity.map?.polyline || activity.map?.summary_polyline;
      else placeholder
    "
    [polyline]="activity.map?.summary_polyline"
    [type]="activity.type"
  ></app-polyline-map>
  <ng-template #placeholder><img class="placeholder" /></ng-template>
  <div class="itemDetails">
    <div class="boldTitle">{{ activity.name }}</div>
    <div *ngIf="activity.distance > 0 && activity.total_elevation_gain > 0">
      {{ activity.distance | distance : "show" }} ·
      {{ activity.total_elevation_gain + " m"  }} ·
      {{ activity.moving_time | elapsed : "strava" }}
    </div>
    <div *ngIf="activity.distance > 0 && !activity.total_elevation_gain">
      {{ activity.distance | distance : "show" }} ·
      {{ activity.moving_time | elapsed : "strava" }}
    </div>
    <div>{{ label }}</div>
  </div>
</div>
